// All Material Ui Items

import {
	createTheme,
	ThemeProvider,
	useTheme,
	styled,
	alpha,
} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import Switch from "@mui/material/Switch";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import Badge from "@mui/material/Badge";
import ButtonBase from "@mui/material/ButtonBase";
import Avatar from "@mui/material/Avatar";
import Drawer from "@mui/material/Drawer";
import Chip from "@mui/material/Chip";
import Card from "@mui/material/Card";
import Fab from "@mui/material/Fab";
import Tooltip from "@mui/material/Tooltip";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Link from "@mui/material/Link";
import Divider from "@mui/material/Divider";
import { grey, red, orange } from "@mui/material/colors";
import Slide from "@mui/material/Slide";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Modal from "@mui/material/Modal";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ListSubheader from "@mui/material/ListSubheader";
import Alert from "@mui/material/Alert";
import Backdrop from "@mui/material/Backdrop";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const COLORS = { grey, red, orange };

export {
	Box,
	Typography,
	CircularProgress,
	createTheme,
	ThemeProvider,
	CssBaseline,
	Container,
	Checkbox,
	Switch,
	Button,
	TextField,
	FormControl,
	FormControlLabel,
	Grid,
	Stack,
	Paper,
	useTheme,
	useMediaQuery,
	AppBar,
	Toolbar,
	IconButton,
	OutlinedInput,
	InputAdornment,
	Badge,
	ButtonBase,
	Avatar,
	Drawer,
	COLORS,
	styled,
	Chip,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Card,
	Fab,
	Tooltip,
	Link,
	Divider,
	Slide,
	useScrollTrigger,
	Menu,
	MenuItem,
	Modal,
	InputLabel,
	Select,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	ListSubheader,
	Alert,
	Backdrop,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	alpha,
};
